import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1db3aa66"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "estimation-result-title" }, "お見積り結果", -1))
const _hoisted_2 = { class: "estimation-result" }
const _hoisted_3 = {
  key: 0,
  class: "term"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "渡航期間：", -1))
const _hoisted_5 = { class: "value" }
const _hoisted_6 = { class: "result" }
const _hoisted_7 = { class: "result-list" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "table-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "product amount" }, "商品内容"),
  /*#__PURE__*/_createElementVNode("div", { class: "price" }, "料金"),
  /*#__PURE__*/_createElementVNode("div", { class: "tax-category" }, "内消費税")
], -1))
const _hoisted_9 = { class: "table-body" }
const _hoisted_10 = { class: "amount" }
const _hoisted_11 = { class: "price" }
const _hoisted_12 = { class: "tax-category" }
const _hoisted_13 = { class: "result-price" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "合計金額：", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("dt", null, "在庫状況：", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block cancel-condition" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "cancel-condition-title" }, "キャンセル料金について"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" 申込日が出発日7日前以前は、出発日の6日前まで無料キャンセルが可能です（翌々日配達地域は、7日前まで）。"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 申込日が出発日6日前以降は、申込日当日は無料キャンセルが可能です。 ")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "annotation" }, " ※上記期日以降は、発送業務の都合上キャンセルは出来ません。 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isDatesFilledIn)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.dateFormat(_ctx.departureDate)) + "～" + _toDisplayString(_ctx.dateFormat(_ctx.arrivalDate)) + " " + _toDisplayString(_ctx.calculateTravelingDays(_ctx.departureDate, _ctx.arrivalDate)) + "日間 ", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("dl", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.estimationData.detailInfo, (detail) => {
              return (_openBlock(), _createElementBlock("div", {
                key: detail.pro_name_show,
                class: "row"
              }, [
                _createElementVNode("dt", null, _toDisplayString(detail.pro_name_show), 1),
                _createElementVNode("dd", null, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(detail.pro_qty_show), 1),
                  _createElementVNode("div", _hoisted_11, _toDisplayString(detail.pro_amount), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(detail.pro_amount_tax), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("dl", _hoisted_13, [
          _createElementVNode("div", null, [
            _hoisted_14,
            _createElementVNode("dd", null, _toDisplayString(_ctx.estimationData.orderInfo.order_grand_total.toLocaleString()) + "円 ", 1)
          ]),
          _createElementVNode("div", null, [
            _hoisted_15,
            _createElementVNode("dd", null, _toDisplayString(Number(this.estimationData.orderInfo.zaiko_flag)
                ? "在庫あり"
                : "在庫なし"), 1)
          ])
        ])
      ]),
      _hoisted_16
    ])
  ], 64))
}